/* eslint-disable react/prop-types */
import useConnectionContext from '@/hooks/useConnectionContext';
import { useNavigate } from 'react-router-dom';

import classes from './Footer.module.css';
// import 'react-loading-skeleton/dist/skeleton.css';

const TITLE = 'You haven‘t set up any payment methods yet';
const SUBTITLE = 'To enable Seel products, you need to add a valid payment method.';

export default function Footer({ showNavItems }) {
  const { payment } = useConnectionContext();
  const { connected = true, buttonText } = payment;
  const navigate = useNavigate();
  const { pathname } = window.location;
  const isAccountPage = pathname.indexOf('billing') > -1;
  if (!showNavItems || connected || isAccountPage) return null;
  const handleJump = () => {
    navigate('/billing/account-settings');
  };
  return (
    <>
      <div className={classes.footer}>
        <div className={classes.footer_content}>
          <div className={classes.footer_left}>
            <div>{TITLE}</div>
            <div>{SUBTITLE}</div>
          </div>
          <div
            className={classes.footer_right}
            onClick={handleJump}
          >
            {buttonText}
          </div>
        </div>
      </div>
      <div className={classes.footer_placeholder}></div>
    </>
  );
}
